var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chatHistory",staticClass:"chat-history"},_vm._l((_vm.messages),function(message,index){return _c('div',{key:index,staticClass:"message",class:{ 'sent': message.sender.includes('teacher'), 'received': !message.sender.includes('teacher')}},[_vm._v(" "+_vm._s(message.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }